import moment from 'moment/moment';
import classes from './TimelineItem.module.css';

function TimelineItem({ eventData: event }) {
  const duration = moment
    .duration(moment(event.endTime).diff(moment(event.startTime)))
    .asMinutes();

  return (
    <div
      key={`${event.idcode}T${moment(event.startTime).format('HHmm')}`}
      className={classes.itemContainer}
      style={{
        height: `${duration * 5}px`,
        position: 'relative',
        visibility: `${event.empty ? 'hidden' : 'visible'}`,
      }}
    >
      <h2 className={classes.title}>
        {event.epgName || event.hebDesc || event.Subject}{' '}
      </h2>

      {duration > 15 && (
        <div>
          <div className={classes.eventTimes}>
            <h3>{'התחלה: ' + moment(event.startTime).format('HH:mm')}</h3>
            <h3>{'סיום: ' + moment(event.endTime).format('HH:mm')}</h3>
          </div>

          <h2 className={classes.eventDesc}>
            {event.hebDesc || event.Subject}
          </h2>
        </div>
      )}
    </div>
  );
}

export default TimelineItem;
